// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9da357c","embedded":"_be916ed","subImageWrapper":"_bc57303","subImage":"_b9d2e85","imageWrapper":"_f4efabb","image":"_103ee1a"};